// Parallax
import React from "react";
import { ParallaxProvider } from "react-scroll-parallax";

export const wrapPageElement = ({ element, props }) => {
	return <ParallaxProvider>{element}</ParallaxProvider>;
};
